export default __webpack_public_path__ + "static/media/chevron-up.e1936f0b.svg";